import React from 'react';

const SVG = ({
  fill = '#fff',
  width = '100%',
  height = '100%',
  className = 'linkedinSVG',
}) => {
  const hoverRef = React.createRef();
  const onHoverOn = e => {
    const hover = hoverRef.current;
    hover.classList.toggle('linkedinSVG_hover');
  };
  const onHoverOut = e => {
    const hover = hoverRef.current;
    hover.classList.toggle('linkedinSVG_hover');
  };
  return (
    <svg
      viewBox="0 0 288 267.5"
      height={height}
      width={width}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={onHoverOn}
      onMouseLeave={onHoverOut}
      ref={hoverRef}
    >
      <g>
        <path
          d="M227.2,29.8H60.8C49.4,29.8,40,39.1,40,50.5v166.4c0,11.4,9.4,20.8,20.8,20.8h166.4c11.4,0,20.8-9.4,20.8-20.8V50.5
			C248,39.1,238.6,29.8,227.2,29.8z M102.4,206.6H71.2v-93.6h31.2V206.6z M86.8,95.3c-10.4,0-18.7-8.3-18.7-18.7s8.3-18.7,18.7-18.7
			s18.7,8.3,18.7,18.7S97.2,95.3,86.8,95.3z M216.8,206.6h-31.2v-55.1c0-8.3-7.3-15.6-15.6-15.6s-15.6,7.3-15.6,15.6v55.1h-31.2
			v-93.6h31.2v12.5c5.2-8.3,16.6-14.6,26-14.6c19.8,0,36.4,16.6,36.4,36.4V206.6z"
        />
      </g>
    </svg>
  );
};

export default SVG;
